/*
 * @Author: Teemo Ding
 * @Date: 2021-12-14 15:02:53
 * @LastEditTime: 2023-02-01 13:56:19
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/ShoppingCartTemplate/ShoppingCartTemplateDetail/index.tsx
 */
import { Button, DropDown } from '@/src/components/Antd';
// import Customer from '../../Components/Customer';
import Menu from '@/src/components/Antd/Menu/Menu';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import { useI18n } from '@/src/hooks/useRouterChange';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  applyShoppingCartTemplate,
  deleteShoppingCartTemplate,
  getShoppingCartTemplate,
  saveShoppingCartTemplate,
} from '@/src/request/order/shoppingCartTemplate';
import { getLanguageList } from '@/src/request/salesChannel/multiLanguage';
import { NEW } from '@/src/tools/constant';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import { i18nGet } from '@/src/tools/tools';
import { TemplateStatus } from '@/src/types/common/order';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Form, message } from 'antd';
import { get, isNumber } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Layout from 'src/layout/DetailPageLayout';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import { getParameter, randomNumber } from 'src/tools/helper';
import Discount from '../../Components/Discount';
import OrderInfoRight from '../../Components/OrderInfoRight';
import Products from '../../Components/Products';
import SalesChannel from '../../Components/SalesChannel';
import StatusTag from '../../Components/StatusTag';
import { discountCalculate } from '../../common';
import ShoppingCartUrl from './ShoppingCartURL';
import css from './css.module.less';
import { breadcrumbData } from './tool';
import { moreThanOneExclusiveCodeErrorCodes } from 'src/tools/constant';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
interface IParams {
  uuid: string;
}
const formName = 'shoppingCartTemplateDetail';

const permissions = () => {
  const view_shopping_cart_template_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.view_shopping_cart_template_details_page,
      }),
    ],
  });
  const create_edit_shopping_cart_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.create_edit_shopping_cart_template,
      }),
    ],
  });
  const notify_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.notify_customer,
      }),
    ],
  });
  const switch_status = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.switch_status,
      }),
    ],
  });
  const delete_shopping_cart_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.delete_shopping_cart_template,
      }),
    ],
  });
  return {
    view_shopping_cart_template_details_page,
    create_edit_shopping_cart_template,
    notify_customer,
    switch_status,
    delete_shopping_cart_template,
  };
};

const ShoppingCartTemplateDetail = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    view_shopping_cart_template_details_page,
    create_edit_shopping_cart_template,
    notify_customer,
    switch_status,
    delete_shopping_cart_template,
  } = permissions();
  const history = useHistory();
  const [form] = Form.useForm();

  const params = useParams<IParams>();
  const duplicate = getParameter('duplicate');
  const [dbUuid, setDbUuid] = useState('');
  const [shoppingCartTemplate, setShoppingCartTemplate] = useState({} as any);
  const { uuid: shoppingCartTemplateUuid } = params;
  const [salesChannelUuid, setSalesChannelUuid] = useState('');
  const salesChannels = useSelector(getSalesChannels()) || [];
  const currentSalesChannel = salesChannels.find(
    (i) => i.uuid === salesChannelUuid,
  );
  const decimalPosition = isNumber(get(currentSalesChannel, 'decimalPosition'))
    ? get(currentSalesChannel, 'decimalPosition')
    : 2;
  const scTimezoneUTC = get(currentSalesChannel, 'timezoneGmt') || '';
  const [leftProducts, setLeftProducts] = useState([]);
  const [hasProducts, setHasProducts] = useState(false);
  const [hasModified, setHasModified] = useState(false);
  const {
    run: _getShoppingCartTemplate,
    data: {
      clickCount,
      appliedOrders = [],
      // shoppingCartTemplate = {},
      shoppingCartUrl = '',
    } = {} as any,
  } = useRequest(() => getShoppingCartTemplate(shoppingCartTemplateUuid), {
    ready:
      shoppingCartTemplateUuid !== NEW &&
      view_shopping_cart_template_details_page,
    onSuccess: (res) => {
      const { salesChannels, shoppingCartTemplate = {} as any } = res;
      const { products, salesChannelUuid, discountCodes } =
        shoppingCartTemplate || {};

      const hasProducts = (products || []).length > 0;
      setLeftProducts(products);
      setHasProducts(hasProducts);

      const salesChannelIndex = salesChannels.filter(
        (o) => o.uuid == salesChannelUuid,
      );
      if (duplicate) {
        shoppingCartTemplate.status = TemplateStatus.Draft;
        setHasModified(true);
      }
      setShoppingCartTemplate(shoppingCartTemplate);
      setDbUuid(get(salesChannelIndex[0], 'customerDatabase.uuid'));
      setSalesChannelUuid(get(salesChannelIndex, ['0', 'uuid']));
      form.setFieldsValue({
        products,
        salesChannel: salesChannelIndex[0],
        salesRepresentative: shoppingCartTemplate.salesRepresentative,
        discountCodes,
      });
      _applyShoppingCartTemplate(shoppingCartTemplate);
    },
  });
  const {
    run: _applyShoppingCartTemplate,
    data: {
      formattedDiscountPrice = '',
      formattedSutTotalPrice = '',
      formattedTotalPrice = '',
      currency = '',
      discountPrice,
    } = {},
  } = useRequest((data) => applyShoppingCartTemplate(data), {
    manual: true,
    onSuccess: (res) => {
      const {
        discountSelections = [],
        products = [],
        discountCodes = [],
        promotionChanged = false,
        promptMsg = '',
      } = res;
      if (promotionChanged) {
        message.warning(promptMsg);
      }
      //给discount加一个唯一的key
      const discountSelectionsAll = (discountSelections || []).map((item) => ({
        ...item,
        ...(get(item, 'giftSelection') && {
          giftSelection: {
            ...item.giftSelection,
            ...(get(item, 'giftSelection.products') && {
              products: get(item, 'giftSelection.products', []).map(
                (product) => {
                  product.children = null;
                  return {
                    ...product,
                    keyUuid: randomNumber(),
                  };
                },
              ),
            }),
          },
        }),
      }));

      //给discount加一个唯一的key
      const productsAll = products.map((item) => ({
        ...item,
        keyUuid: randomNumber(),
      }));
      form.setFieldsValue({
        products: productsAll,
        discountCodes,
        discountSelections: discountSelectionsAll,
      });
    },
    onError: (e: any) => {
      const discountCodes = form.getFieldValue('discountCodes') || [];
      const { errorCode } = e;
      if (moreThanOneExclusiveCodeErrorCodes.includes(errorCode)) {
        discountCodes.pop();
        form.setFieldsValue({
          discountCodes,
        });
      }
    },
  });

  const { run: _getLanguageList, data: availableLanguage = [] } = useRequest(
    (data) => getLanguageList(data),
    {
      manual: true,
      onSuccess: (res) => {
        const primaryLanguage = res.filter((o) => o.primary);
        form.setFieldsValue({ languageCode: primaryLanguage[0] });
      },
    },
  );

  const { run: _deleteShoppingCartTemplate } = useRequest(
    () => deleteShoppingCartTemplate(shoppingCartTemplateUuid),
    {
      manual: true,
      onSuccess: (res) => {
        message.success('delete successfully');
        history.push('/order/shoppingCart/list');
      },
    },
  );
  const { run: _saveShoppingCartTemplate } = useRequest(
    (data) => saveShoppingCartTemplate(data),
    {
      manual: true,
      onSuccess: (res) => {
        const {
          shoppingCartTemplate: { uuid },
        } = res;

        setHasModified(false);
        if ((shoppingCartTemplateUuid == NEW && uuid) || duplicate) {
          history.replace(`/order/shoppingCart/edit/${uuid}`);
        } else {
          _getShoppingCartTemplate();
        }
      },
    },
  );

  const handleApply = (combineData?) => {
    const salesChannelUuid =
      (form.getFieldValue('salesChannel') || {}).uuid || '';
    const products = form.getFieldValue('products') || [];
    const discountCodes = form.getFieldValue('discountCodes') || [];
    const allSelectedGift = discountCalculate(
      form.getFieldValue('discountSelections') || [],
    );
    const data = {
      salesChannelUuid,
      products,
      discountCodes: discountCodes.length ? discountCodes : null,
      ...allSelectedGift,
      ...combineData,
    };
    if ((data.products || []).length) {
      _applyShoppingCartTemplate(data);
    } else {
      form.setFieldsValue({
        discountSelections: [],
      });
      // setSummary({
      //   ...summary,
      //   formattedDiscountPrice: '0.00',
      //   formattedSutTotalPrice: '0.00',
      //   formattedTotalPrice: '0.00',
      // });
    }
  };

  const beforeGoBack = () => {
    history.push('/order/shoppingCart/list');
  };

  const onValuesChange = (values) => {
    setHasModified(true);
    if (Object.keys(values).includes('salesChannel')) {
      const scUuid = get(values, 'salesChannel.uuid');
      setDbUuid(get(values, 'salesChannel.customerDatabase.uuid'));
      _getLanguageList(scUuid);
      setSalesChannelUuid(scUuid);
    }
    if (Object.keys(values).includes('products')) {
      const products = get(values, 'products') || [];
      setHasProducts(products.length !== 0);
      setLeftProducts(products);
      handleApply({ products });
    }
  };

  const buildData = (data, status?) => {
    const { salesChannel, products, discountSelections, salesRepresentative } =
      data;
    const allSelectedGift = discountCalculate(discountSelections || []);
    const discountCodes = form.getFieldValue('discountCodes') || [];
    const createOrderData = {
      uuid:
        shoppingCartTemplateUuid == NEW || duplicate
          ? ''
          : shoppingCartTemplateUuid,
      salesChannelUuid: salesChannel.uuid,
      discountPrice,
      discountCodes,
      products,
      salesRepresentative,
      status: status || shoppingCartTemplate.status || TemplateStatus.Draft,
      ...allSelectedGift,
    };

    return createOrderData;
  };

  const onFinish = (values) => {
    const data = buildData(values);
    _saveShoppingCartTemplate(data);
  };
  const handleChangeStatus = (status) => {
    const values = form.getFieldsValue();
    const data = buildData(values, status);
    _saveShoppingCartTemplate(data);
  };
  const overlay = React.useMemo(
    () => (
      <div className={css.menu}>
        <Menu>
          <MenuItem onClick={(e) => handleChangeStatus(TemplateStatus.Active)}>
            <StatusTag className={css.status} status={TemplateStatus.Active} />
          </MenuItem>
          <MenuItem onClick={(e) => handleChangeStatus(TemplateStatus.Draft)}>
            <StatusTag className={css.status} status={TemplateStatus.Draft} />
          </MenuItem>
          <MenuItem onClick={(e) => handleChangeStatus(TemplateStatus.Locked)}>
            <StatusTag className={css.status} status={TemplateStatus.Locked} />
          </MenuItem>
        </Menu>
      </div>
    ),
    [shoppingCartTemplate.status],
  );

  const leftGenerate = () => {
    return (
      <Form
        form={form}
        name={formName}
        onValuesChange={onValuesChange}
        onFinish={onFinish}>
        <Element>
          <SalesChannel
            disable={
              shoppingCartTemplate.status === TemplateStatus.Locked ||
              !create_edit_shopping_cart_template
            }
            hideLanguage
            availableLanguage={availableLanguage}
          />
        </Element>
        <Element>
          <Form.Item
            noStyle
            shouldUpdate={(p, c) => {
              const cC = get(c, 'salesChannel.uuid');
              const pC = get(p, 'salesChannel.uuid');
              return cC !== pC;
            }}>
            {({ getFieldValue }: any) => {
              const currency = get(getFieldValue('salesChannel'), 'currency');
              return (
                <Products
                  disable={
                    shoppingCartTemplate.status === TemplateStatus.Locked ||
                    !create_edit_shopping_cart_template
                  }
                  currency={currency}
                  keyUuid='keyUuid'
                />
              );
            }}
          </Form.Item>
        </Element>
        <Element>
          <Discount
            disable={
              shoppingCartTemplate.status === TemplateStatus.Locked ||
              !create_edit_shopping_cart_template
            }
            form={form}
            currency={currency}
            handleApply={handleApply}
            keyUuid='keyUuid'
            handleOnHasModified={() => {
              setHasModified(true);
            }}
            decimalPosition={decimalPosition}
            scTimezoneUTC={scTimezoneUTC}
          />
        </Element>
      </Form>
    );
  };

  const duplicateShoppingCartTemplate = () => {
    history.replace(
      `/order/shoppingCart/edit/${shoppingCartTemplateUuid}?duplicate=true`,
    );
    history.go(0);
  };

  const moreActionsOverlay = (
    <div className={css.menu}>
      <Menu>
        <MenuItem
          disabled={!create_edit_shopping_cart_template}
          onClick={duplicateShoppingCartTemplate}>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_moreActionsOverlay_duplicate_item',
          )}
        </MenuItem>
        <MenuItem
          disabled={!delete_shopping_cart_template}
          onClick={_deleteShoppingCartTemplate}>
          {getI18n(
            'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_moreActionsOverlay_delete_item',
          )}
        </MenuItem>
      </Menu>
    </div>
  );
  return (
    <div>
      <Layout
        leftPart={leftGenerate()}
        header={
          <div className={css.header}>
            <TopLeft
              goBack={beforeGoBack}
              breadcrumbData={breadcrumbData({ getI18n })}
            />
            <TopRight
              {...(shoppingCartTemplate.status !== TemplateStatus.Locked
                ? { onDiscard: beforeGoBack, onSubmit: form.submit }
                : {})}
              onSaveDisable={!hasModified}
              extendButton={
                <Fragment>
                  {!duplicate &&
                    shoppingCartTemplate.status === TemplateStatus.Active && (
                      <DropDown.Button
                        disabled={
                          !create_edit_shopping_cart_template &&
                          !delete_shopping_cart_template
                        }
                        icon={<Icon type='icondown' />}
                        className={css.extendButton}
                        overlay={moreActionsOverlay}
                        placement='bottomRight'
                        trigger={['click']}>
                        {getI18n(
                          'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_return_actions_btn',
                        )}
                      </DropDown.Button>
                    )}
                  {shoppingCartTemplate.status !== TemplateStatus.Active &&
                    shoppingCartTemplate.status !== TemplateStatus.Locked && (
                      <Button
                        className={css.headerButton}
                        onClick={() =>
                          handleChangeStatus(TemplateStatus.Active)
                        }
                        type='primary'
                        disabled={!create_edit_shopping_cart_template}>
                        {getI18n(
                          'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_return_createShoppingCart_btn',
                        )}
                      </Button>
                    )}
                  {shoppingCartTemplate.status === TemplateStatus.Locked && (
                    <Button
                      className={css.headerButton}
                      onClick={duplicateShoppingCartTemplate}
                      type='primary'
                      disabled={!create_edit_shopping_cart_template}>
                      {getI18n(
                        'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_return_Duplicate_btn',
                      )}
                    </Button>
                  )}
                </Fragment>
              }
            />
          </div>
        }
        rightElements={[
          {
            child: (
              <OrderInfoRight
                title={
                  shoppingCartTemplate.status ? (
                    <div className={css.dropDown}>
                      <DropDown
                        overlay={overlay}
                        placement='bottomRight'
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentElement
                        }
                        trigger={['click']}
                        disabled={!switch_status}>
                        <div>
                          <StatusTag
                            className={css.status}
                            status={shoppingCartTemplate.status}
                          />
                          <Icon type='icondown1' className={css.moreIcon} />
                        </div>
                      </DropDown>
                      {`${getI18n(
                        'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_return_rightElements_OrderInfoRight_titleYes',
                      )} ${shoppingCartTemplate.cartNo}`}
                    </div>
                  ) : (
                    getI18n(
                      'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_return_rightElements_OrderInfoRight_titleNo',
                    )
                  )
                }
                orderDetail={{
                  productAmount: leftProducts.reduce(
                    (p, c) => p + (c.amount || 1),
                    0,
                  ),
                  subTotal: hasProducts
                    ? formattedSutTotalPrice || '-'
                    : '0.00',
                  discount: hasProducts
                    ? formattedDiscountPrice || '-'
                    : '0.00',
                  total: hasProducts ? formattedTotalPrice || '-' : '0.00',
                }}
              />
            ),
          },
          ...(shoppingCartTemplate.status == TemplateStatus.Active ||
          shoppingCartTemplate.status == TemplateStatus.Locked
            ? [
                {
                  child: (
                    <ShoppingCartUrl
                      dbUuid={dbUuid}
                      salesChannelUuid={salesChannelUuid}
                      shoppingCartUrl={shoppingCartUrl}
                      clickCount={clickCount}
                      appliedOrders={appliedOrders}
                      disabled={!notify_customer}
                      disableCopy={!view_shopping_cart_template_details_page}
                      timezoneInGmt={shoppingCartTemplate.timezoneInGmt}
                    />
                  ),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default ShoppingCartTemplateDetail;
